import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Builder from "./sections/Builder";
import Builders from "./sections/Builders";
import Comparison from "./sections/Comparison";
import Guidance from "./sections/Guidance";
import Journey from "./sections/Journey";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Builder />
      <Builders />
      <Comparison />
      <Guidance />
      <Journey />
      <Footer />
    </div>;
}